enum SearchBarEvents {
  ClearedText = 'Search Bar Cleared Text',
  Focused = 'Search Bar Focused',
  NoResults = 'No Results',
  PressedEnter = 'Pressed Enter',
  RemovedRecentSearch = 'Removed Recent Search',
  SuggestionClicked = 'Suggestion Clicked',
  TypedNoSubmit = 'Typed But Did Not Submit'
}

export default SearchBarEvents;
